  <div class="row rounded-card" id="brands-settings">
    <div class="flex flex-wrap justify-between items-end mb-4" id="setting-view-header-wr">
      <div class="flex flex-col">
        <h2 data-testid="brands-title">{{ 'SYSTEM_SETTINGS.BRANDS.TITLE' | translate }}</h2>
        <span class="text-base">{{ 'SYSTEM_SETTINGS.BRANDS.SUBTITLE' | translate }}</span>
      </div>

      <div class="flex items-center gap-2">
        <button data-testid="add-brand-btn" class="btn primary-btn" (click)="openCreateBrandModalbox()">{{ 'SYSTEM_SETTINGS.BRANDS.BTN_ADD_BRAND' | translate }}</button>
      </div>
    </div>

    <hr class="mb-1 mt-2 border-t">

    <form [formGroup]="defaultBrandForm">
      <div class="col-12 mb-4">
        @if (showBrandRequiredNotice) {
          <app-notice
            class="block mt-3 mb-3"
            type="yellow"
            dataTestId="company-brand-required-notice"
            [title]="'SYSTEM_SETTINGS.COMPANY.BRAND_REQUIRED_NOTICE_TITLE' | translate"
            [message]="'SYSTEM_SETTINGS.COMPANY.BRAND_REQUIRED_NOTICE_MESSAGE' | translate">
          </app-notice>
        }
        <h3 data-testid="company-general-info"  class="border-b pb-3">{{ 'SYSTEM_SETTINGS.COMPANY.GENERAL_INFORMATION' | translate }}</h3>
      </div>
      <div class="field-wr col-12">
        <label data-testid="company-default-brand-label" class="block text-sm mb-2" for="defaultBrandId">
          {{ 'SYSTEM_SETTINGS.COMPANY.DEFAULT_BRAND' | translate }}
        </label>

        <div style="display: flex; align-items: center; gap: 1rem;">
          <div style="flex: 1 1 220px; min-width: 220px;">
            <app-custom-dropdown
                style="display: block; width: 90%;"
                data-testid="company-default-brand-dropdown"
                [options]="defaultBrandOptions"
                optionLabel="text"
                optionValue="id"
                [isMultiselect]="false"
                [showSelectionChips]="true"
                [showClear]="false"
                [showSearchbox]="false"
                [searchMode]="'local'"
                [pageSize]="10"
                (ngModelChange)="onDefaultBrandDropdownChange($event)"
                formControlName="defaultBrandId"
                [placeholder]="'SYSTEM_SETTINGS.COMPANY.DEFAULT_BRAND' | translate">
            </app-custom-dropdown>
          </div>

          <div style="flex: 0 0 auto;">
            <button type="button" data-testid="update-brand-btn" class="btn primary-btn" (click)="onUpdateDefaultBrandButtonClick()">{{ 'SYSTEM_SETTINGS.BRANDS.BTN_UPDATE_BRAND' | translate }}</button>
          </div>
        </div>

        <small class="text-sm mt-2">
          <em>{{ 'SYSTEM_SETTINGS.COMPANY.DEFAULT_BRAND_HELPER' | translate }}</em>
        </small>
      </div>
    </form>

    <hr class="mb-1 mt-2 border-t">
    <section>
      <div class="col-12 mt-4">
        <p-table [value]="paginatedBrands" [loading]="loading">
          <ng-template #header>
            <tr>
              <th>
                <div class="header-wr">
                  <span data-testid="brand-name-header" class="col-name">{{ 'SYSTEM_SETTINGS.BRANDS.TH_NAME' | translate }}</span>
                </div>
              </th>
              <th>
                <div class="header-wr text-center">
                  <span data-testid="brand-actions-header" class="col-name w-100">{{ 'SYSTEM_SETTINGS.BRANDS.TH_ACTIONS' | translate }}</span>
                </div>
              </th>
            </tr>
          </ng-template>
          <ng-template #body let-brand let-rowIndex="rowIndex">
            <tr [attr.data-id]="brand.id">
              <td>
                <span class="p-column-title">{{ 'SYSTEM_SETTINGS.BRANDS.TD_NAME' | translate }}</span>
                <span [attr.data-testid]="'brand-name-' + rowIndex">{{ brand.name | defaultValue }}</span>
              </td>
              <td class="actions-col">
                <div class="brand-actions gap-2">
                  <p-toggleswitch class="centered" [(ngModel)]="brand.isActive" (onChange)="onStateChange($event, brand)" [attr.data-testid]="'switch-' + rowIndex" />

                  <button type="button" pTooltip="{{ 'SYSTEM_SETTINGS.BRANDS.BTN_EDIT' | translate }}" tooltipPosition="top" class="btn-icon-only ui-btn-view btn-icon icon-edit" (click)="onViewBrand($event, brand)" [attr.data-testid]="'edit-' + rowIndex">
                    <span class="btn-label">{{ 'SYSTEM_SETTINGS.BRANDS.BTN_EDIT' | translate }}</span>
                  </button>

                  <button type="button" pTooltip="Digital card settings" tooltipPosition="top" class="btn-icon-only ui-btn-view btn-icon icon-digital-card" data-testid="brand-digital-card-btn" (click)="openDigitalCardSettingsModalbox(brand)">
                    <span class="btn-label">{{ 'SYSTEM_SETTINGS.TABS.DIGITAL_CARD' | translate }}</span>
                  </button>

                  <button type="button" pTooltip="{{ 'SYSTEM_SETTINGS.BRANDS.BTN_DELETE' | translate }}" tooltipPosition="top" class="btn-icon-only ui-btn-delete btn-icon icon-delete" (click)="showDeleteDialog($event, brand)" [attr.data-testid]="'delete-' + rowIndex">
                    <span class="btn-label">{{ 'SYSTEM_SETTINGS.BRANDS.BTN_DELETE' | translate }}</span>
                  </button>
                </div>
              </td>
            </tr>
          </ng-template>
          <ng-template #emptymessage>
            <tr>
              <td colspan="2">{{ 'SYSTEM_SETTINGS.BRANDS.TABLE_NO_DATA' | translate }}</td>
            </tr>
          </ng-template>
        </p-table>

        <!-- Pagination -->
        <app-custom-paginator
          data-testid="brands-paginator"
          [first]="paginatorFirst"
          [rows]="paginatorRows"
          [totalRecords]="totalRecords"
          [rowsPerPageOptions]="[10, 20, 50]"
          [showCurrentPageReport]="true"
          [currentPageReportTemplate]="'PAGINATOR.CURRENT_PAGE_REPORT' | translate"
          [disabled]="totalRecords === 0"
          [alwaysShow]="true"
          [showFirstLastIcon]="true"
          [showPageLinks]="true"
          [showPageSizeSelector]="true"
          (onPageChange)="onPageChange($event)">
        </app-custom-paginator>
      </div>
    </section>
  </div>

  <!-- Modalbox: Create/update brand -->
  <p-dialog [(visible)]="showBrandModalbox" [modal]="true" [closable]="true" [blockScroll]="true" [draggable]="false" [resizable]="false" [dismissableMask]="true" [header]="(selectedBrandId ? 'SYSTEM_SETTINGS.BRANDS.BTN_UPDATE_BRAND' : 'SYSTEM_SETTINGS.BRANDS.BTN_CREATE_BRAND') | translate" (onHide)="closeBrandModalbox()">
    <form class="mt-0" [formGroup]="brandForm">
      <div class="row">
        <div class="field-wr flex flex-col col-12 mb-3">
          <label for="brandName">{{ 'SYSTEM_SETTINGS.BRANDS.MODALBOX_BRAND_NAME' | translate }} <i class="icon-required-field"></i></label>
          <input id="brandName" type="text" formControlName="name" autocomplete="off" />
          @if (brandForm.get('name')?.invalid && brandForm.get('name')?.touched) {
            <small data-testid="brand-name-mandatory" class="p-error">
              {{ 'FORMS.MANDATORY_FIELD' | translate }}
            </small>
          }
        </div>

        <div class="field-wr flex flex-col col-12 mb-3">
          <label>{{ 'SYSTEM_SETTINGS.BRANDS.MODALBOX_BRAND_LOGO' | translate }}</label>
          @if (uploadedLogoUrl) {
            <div class="logo-preview-container">
              <div class="logo-preview">
                @if (!brandLogoLoadFailed) {
                  <img
                    [src]="uploadedLogoUrl"
                    alt="Brand logo"
                    class="logo-thumbnail"
                    (error)="onLogoLoadError()" />
                }

                @if (brandLogoLoadFailed) {
                  <div class="logo-fallback flex flex-col items-center text-center gap-2">
                    {{ 'SYSTEM_SETTINGS.THEME.IMAGE_BROKEN' | translate }}

                    <button
                      data-testid="upload-brand-logo-btn"
                      type="button"
                      class="btn text-sm mt-2 border-none"
                      (click)="showUploadPrompt()">
                      {{ 'SYSTEM_SETTINGS.THEME.UPLOAD_LOGO' | translate }}
                    </button>
                  </div>
                }

                @if (!brandLogoLoadFailed) {
                  <button
                    data-testid="remove-brand-logo-btn"
                    type="button"
                    class="btn text-sm outline-btn"
                    (click)="onBrandLogoRemove()">
                    {{ 'SYSTEM_SETTINGS.THEME.REMOVE_LOGO' | translate }}
                  </button>
                }
              </div>
            </div>
          } @else {
            <p-fileUpload
              data-testid="upload-brand-logo-input"
              name="brandLogo"
              accept=".png"
              maxFileSize="10485760"
              chooseLabel="{{ 'SYSTEM_SETTINGS.THEME.BTN_ATTACH_LOGO_FILE' | translate }}"
              [customUpload]="true"
              [showUploadButton]="false"
              [showCancelButton]="false"
              (onSelect)="onBrandLogoSelected($event)">

              <ng-template pTemplate="empty">
                <div class="flex items-center justify-center flex-col">
                  <i class="pi pi-cloud-upload border-2"></i>

                  <p class="mt-2 mb-1">
                    {{ 'SYSTEM_SETTINGS.THEME.ATTACH_FILES_BY_DRAG_AND_DROP' | translate }}
                  </p>
                </div>
              </ng-template>
            </p-fileUpload>

            <p class="mt-2">
              <span class="text-sm font-medium">
                {{ 'SYSTEM_SETTINGS.BRANDS.MAXIMUM_LOGO_FILE_SIZE' | translate }}
              </span>
            </p>

            <div class="error-hint-wr">
              @if (fileUploadError) {
                <small class="p-error">
                  {{ fileUploadError }}
                </small>
              }
            </div>
          }
        </div>
      </div>
    </form>
    <ng-template #footer>
      <button type="button" class="btn primary-btn" [disabled]="brandForm.invalid || savingBrand" (click)="saveBrand()">{{ (selectedBrandId ? 'SYSTEM_SETTINGS.BRANDS.BTN_UPDATE_BRAND' : 'SYSTEM_SETTINGS.BRANDS.BTN_CREATE_BRAND') | translate }}</button>
    </ng-template>
  </p-dialog>
  <dialog-reason  #dialog [title]="'SYSTEM_SETTINGS.BRANDS.BTN_DELETE'" (onClose)="deleteBrand($event)"></dialog-reason>

  <!-- Modalbox: Digital card -->
  <p-dialog [header]="'SYSTEM_SETTINGS.TABS.DIGITAL_CARD' | translate" [(visible)]="displayDigitalCardSettingsModalbox" [modal]="true" [blockScroll]="true" [draggable]="false" [resizable]="false" [closable]="true" (onHide)="closeDigitalCardSettingsModalbox()" class="digital-card-settings-dialog">
  @if (selectedDigitalCardBrandId !== null) {
    <app-digital-card-settings [brandId]="selectedDigitalCardBrandId" (settingsUpdated)="closeDigitalCardSettingsModalbox()">
    </app-digital-card-settings>
  }
  </p-dialog>

  <!-- Modalbox: Update default brand -->
  <p-dialog [(visible)]="showDefaultBrandUpdateModal" [modal]="true" [blockScroll]="true" [draggable]="false" [resizable]="false" [header]="'SYSTEM_SETTINGS.BRANDS.MODALBOX_TITLE_UPDATE_DEFAULT_BRAND' | translate">
    <section class="row">
      <div class="col-12">
        <p class="pb-3">{{ 'SYSTEM_SETTINGS.BRANDS.MODALBOX_TITLE_UPDATE_DEFAULT_BRAND_INFO' | translate: { brandName: brandToSetDefault?.text } }}</p>
      </div>
    </section>

    <ng-template #footer>
      <button type="button" class="btn outline-btn" (click)="cancelUpdateDefaultBrand()">{{ 'SYSTEM_SETTINGS.BRANDS.BTN_CANCEL' | translate }}</button>
      <button type="button" class="btn primary-btn" [disabled]="updatingDefaultBrand" (click)="updateDefaultBrand()">{{ 'SYSTEM_SETTINGS.BRANDS.BTN_UPDATE_BRAND' | translate }}</button>
    </ng-template>
  </p-dialog>
